import { render, staticRenderFns } from "./WebArticleInputsForm.vue?vue&type=template&id=5b5d1754"
import script from "./WebArticleInputsForm.vue?vue&type=script&lang=js"
export * from "./WebArticleInputsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports